import { makeStyles } from '@mui/styles';
import { COLORS } from '../../../../shared/config/colors';
const styles = makeStyles(({ breakpoints }) => ({
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
    fontSize: '18px',
    cursor: 'pointer'
  },
  menuTogglerBtn: {
    position: 'absolute',
    bottom: '30vh',
    zIndex: 100,
    right: '-20px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  menuTogglerTableBtn: {
    position: 'absolute',
    bottom: '30vh',
    zIndex: 100,
    right: '40.5%',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  filterTogglerTableBtn: {
    position: 'absolute',
    top: '50%',
    right: '-10px',
    transform: 'translateY(-50%)',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    zIndex: 100,
    '&:hover': { backgroundColor: '#c3c3c3' },
  },
  checkBoxCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    gap: 1,
    flexShrink: 0,
    overflow: 'hidden'
  },
  runDetailsFilter: {
    fontSize: '19px',
    fontWeight: 900,
    display: 'flex',
    alignItems: 'center',
    marginLeft: '15px'
  },
  runDetailsTableMarker: {
    position: 'relative',
    padding: 0,
    width: 40,
    height: 40,
    marginLeft: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  filterTableMarker: {
    position: 'relative',
    padding: 0,
    width: 40,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      width: '100%',
      height: 3,
      backgroundColor: COLORS.GRAY,
      transform: 'translateY(-50%)',
    },
  },
  checkBoxValue: {
    whiteSpace: 'nowrap',
    fontWeight: '500',
    fontSize: '16px',
    alignContent: 'center',
    alignItems: 'center'
  },
  lineColorFlow_in: {
    width: 60,
    height: 3,
    marginTop: 0,
    marginBottom: 0,
    alignSelf: 'center',
    [breakpoints.down(500)]: {
      width: 35,
      height: 2,
    }
  },
  lineDashType: {
    width: 60,
    height: 3,
    borderColor: COLORS.GRAY,
    marginTop: 0,
    marginBottom: 0,
    alignSelf: 'center',
    [breakpoints.down(500)]: {
      width: 35,
      height: 2,
    }
  },
  editBox: {
    border: '1px solid grey',
    borderRadius: 1
  },
  xAxisEditBtn: {
    position: 'absolute',
    top: -33,
    left: '24px',
    zIndex: 20
  },
  yAxisEditBtn: {
    position: 'absolute',
    top: -65,
    left: '-8px',
    zIndex: 20
  },
  headerCell: {
    border: '1px solid grey',
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bold',
    padding: '4px',
    height: '20px'
  },
  rowCell: {
    border: '1px solid grey',
    backgroundColor: 'white',
    color: 'black',
    padding: '4px',
    height: '20px'
  },
  tableContainer: {
    maxWidth: 600,
    height: 'auto',
    maxHeight: 730
  },
  gridContainer: {
    paddingTop: '4px',
    borderBottom: '1px solid #ccc'
  },
  gridItem: {
    background: '#F2F2F2',
    paddingBottom: '1px',
    borderBottom: '0.5px solid #FFF',
    textAlign: 'center',
  },
  headerName: {
    flex: 0.5,
    fontWeight: 'bold',
    borderRight: '1px solid #ccc',
    textAlign: 'center',
    alignSelf: 'center'
  },
  accordianScrollUp: {
    position: 'fixed',
    bottom: 10,
    right: 10
  },
}));
export const filterTableWidth = [16, 25, 35];
export default styles;
